import React from 'react';
import { Nav } from '@douyinfe/semi-ui';
import { IconExit, IconKey } from '@douyinfe/semi-icons';
import { updateLastLoginUser } from '../../controllers/userController';

class LoginButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      authenticated: props.authenticated || false,
    };
  }

  keycloakLogin = () => {
    this.props.keycloak
      .login()
      .then((authenticated) => {
        this.setState({ authenticated });
        this.props.onLoginChange(authenticated);
      })
      .catch((error) => {
        console.error('Login error:', error);
      });
  };

  keycloakLogout = () => {
    updateLastLoginUser()
      .then(() => {
        this.props.keycloak.logout({ redirectUri: `${window.location.protocol}//${process.env.REACT_APP_HOST}/` });
        this.setState({ authenticated: false });
        this.props.onLoginChange(false);
      })
      .catch((error) => {
        console.error('Logout error:', error);
      });
  };

  render() {
    const behaviour = this.props.behaviour;
    return (
      <Nav.Item
        itemKey={'login'}
        text={behaviour}
        icon={behaviour === 'Войти' ? <IconKey /> : <IconExit />}
        onClick={behaviour === 'Войти' ? this.keycloakLogin : this.keycloakLogout}
      />
    );
  }
}

export default LoginButton;